import { useRef, useState } from 'react';
import { FileDown, MoreVertical, Trash2 } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useOnClickOutside } from '../../../shared/lib/hooks/use-on-click-outside';
import styles from './ai-advisor-page.module.css';

export const ChatMenu = ({
	onClear,
	onExport,
	isExporting,
	canExport,
	disabled,
}) => {
	const intl = useIntl();
	const [isOpen, setIsOpen] = useState(false);
	const menuRef = useRef(null);

	useOnClickOutside(menuRef, () => setIsOpen(false));

	const select = action => () => {
		setIsOpen(false);
		action();
	};

	return (
		<div className={styles.chatActions} ref={menuRef}>
			<button
				type='button'
				className={styles.chatMenuTrigger}
				onClick={() => setIsOpen(prev => !prev)}
				disabled={disabled || isExporting}
				aria-label='Chat options'
				aria-expanded={isOpen}
			>
				<MoreVertical size={20} />
			</button>
			{isOpen && (
				<div className={styles.chatMenuDropdown} role='menu'>
					<button
						type='button'
						className={styles.chatMenuItem}
						role='menuitem'
						onClick={select(onClear)}
					>
						<Trash2 size={18} className={styles.chatMenuItemIcon} />
						{intl.formatMessage({ id: 'AIAdvisorID6' })}
					</button>
					<button
						type='button'
						className={styles.chatMenuItem}
						role='menuitem'
						onClick={select(onExport)}
						disabled={isExporting || !canExport}
					>
						<FileDown size={18} className={styles.chatMenuItemIcon} />
						{isExporting ? '...' : intl.formatMessage({ id: 'AIAdvisorID12' })}
					</button>
				</div>
			)}
		</div>
	);
};
